/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BooksLibraryIcon20Solid = forwardRef('BooksLibraryIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.5 2.5A1.5 1.5 0 0 1 13 4v12a1.5 1.5 0 1 1-3 0V4a1.5 1.5 0 0 1 1.5-1.5Z" }),
        React.createElement("path", { d: "M15.5 2.5A1.5 1.5 0 0 1 17 4v12a1.5 1.5 0 1 1-3 0V4a1.5 1.5 0 0 1 1.5-1.5Z" }),
        React.createElement("path", { d: "M8.897 5.047a1.5 1.5 0 1 0-2.794-1.094l-4.5 11.5a1.5 1.5 0 0 0 2.794 1.094l4.5-11.5Z" })));
});
